document.addEventListener('DOMContentLoaded', function () {
  const grid = document.querySelector('#product-grid');
  const pagination = document.querySelector('.custom-pagination');
  if (!grid) return;

  const observer = new MutationObserver(() => {
    const hasProduct = grid.querySelector('.card-wrapper');
    if (!hasProduct) return;

      try {
          const customJsonData = window.variantCollectionData;
          console.log("Custom Json data:", customJsonData)
          return
          for (const key in customJsonData) {
            if (!customJsonData.hasOwnProperty(key)) continue;
            const elements = document.querySelectorAll(`.card-wrapper[data-product-id="${key}"]`);
            const dataVariant = customJsonData[key];

            if (!dataVariant || !Array.isArray(dataVariant)) continue;

            let i = 0;
            let elIndex = 0;
            function findPackOfOptions(variant) {
              let foundOptions = [];
              let lengthOption = variant.options.length;

              for (let index = 1; index <= lengthOption; index++) {
                let optionKey = `option${index}`;
                let value = variant?.[optionKey];

                if (typeof value === "string" && value.toLowerCase().includes("pack of")) {
                  foundOptions.push(index); 
                }
              }

              return foundOptions;
            }

        while (i < dataVariant.length && elIndex < elements.length) {
          const el = elements[elIndex];
          const buttonSingle = el.querySelector('.price__label-first');
          const buttonUnit = el.querySelector('.price__label-second');
          const firstPrice = el.querySelector('.price-first .price-item');
          const secondPrice = el.querySelector('.price-second .price-item');
          const starWrapper = el.querySelector('.star.review-card');
          const freeShipping = el.querySelector('.budge__free-shiping');
          let variantData1 = dataVariant[i];
          let variantData2 = dataVariant[i + 1];
        
          let showSecond = false;
         
          let freeShippingStatusSingle = false;
          let freeShippingStatusCase = false;
          let lengthOption = variantData1.options.length;
          let packOfStatus = false;
          for (let index = 1; index <= lengthOption; index++) {
            let optionKey = `option${index}`;
            let value = variantData1?.[optionKey];

            if (typeof value === "string" && value.toLowerCase().includes("pack")) {
              packOfStatus = true;
            }
          }
          if(packOfStatus){
            variantData2 = dataVariant[i + 2];
          }
          
          if (variantData1?.variant_metafields?.['custom.free_shipping_status']) {
            freeShippingStatusSingle = variantData1.variant_metafields['custom.free_shipping_status'] === 'true';
          }

          if (variantData2?.variant_metafields?.['custom.free_shipping_status']) {
            freeShippingStatusCase = variantData2.variant_metafields['custom.free_shipping_status'] === 'true';
          }

          if (freeShipping) {
            const hasAnyFreeShipping = freeShippingStatusSingle || (showSecond && freeShippingStatusCase);
            freeShipping.style.display = freeShippingStatusSingle ? 'block' : 'none'; 
          }

          if (variantData1 && variantData2 && variantData1.option1 === variantData2.option1) {
            showSecond = true;
          }else if (packOfStatus) {
            showSecond = true;
          }
           else {
            variantData2 = null;
            if (secondPrice) secondPrice.classList.add('!hidden');
            if (buttonUnit) buttonUnit.classList.add('!hidden');
          }

          if (!variantData1) {
            i++;
            elIndex++;
            continue;
          }

          const variantPrice1 = variantData1.variantPrice || '';
          const variantId1 = variantData1.id || '';
          const variantAvailable1 = variantData1.available || false;

          if (firstPrice) firstPrice.textContent = variantPrice1;
          if (buttonSingle) {
            buttonSingle.setAttribute('data-variant-id', variantId1);
            buttonSingle.setAttribute('data-free-shipping', freeShippingStatusSingle);
            buttonSingle.classList.toggle('opacity-50', !variantAvailable1);
            buttonSingle.classList.toggle('pointer-events-none', !variantAvailable1);
            if(packOfStatus){
              buttonSingle.textContent=`${variantData1.option3}`
            }
          }

          if (showSecond && variantData2) {
            const variantPrice2 = variantData2.variantPrice || '';
            const variantId2 = variantData2.id || '';
            const variantAvailable2 = variantData2.available || false;

            const variantMetafields = variantData2.variant_metafields;
            let packInfo = '';

            if (variantMetafields && variantMetafields['custom.amount_in_case']) {
              packInfo = variantMetafields['custom.amount_in_case'];
            }

            if (secondPrice) {
              secondPrice.textContent = variantPrice2;
              secondPrice.classList.remove('hidden', '!hidden');
            }

            if (buttonUnit) {
              buttonUnit.textContent = packInfo || 'Case';
              buttonUnit.setAttribute('data-variant-id', variantId2);
              buttonUnit.setAttribute('data-free-shipping', freeShippingStatusCase);
              buttonUnit.classList.remove('hidden', '!hidden');
              buttonUnit.classList.toggle('opacity-50', !variantAvailable2);
              buttonUnit.classList.toggle('pointer-events-none', !variantAvailable2);
              if(packOfStatus){
                buttonUnit.textContent=`${variantData2.option3}`
              }
            }
            // if(packOfStatus && buttonUnit){
            //     const variantPrice3 = variantData3.variantPrice || '';
            //     const variantId3 = variantData3.id || '';
            //     const variantAvailable3 = variantData3.available || false;
            //     const clonedEl = buttonUnit.cloneNode(true);
            //     clonedEl.setAttribute('data-variant-id', variantId3);
            //     clonedEl.setAttribute('data-free-shipping', freeShippingStatusCase);
            //     clonedEl.classList.remove('hidden', '!hidden');
            //     clonedEl.classList.toggle('opacity-50', !variantAvailable3);
            //     clonedEl.classList.toggle('pointer-events-none', !variantAvailable3);
            //     clonedEl.textContent =`${variantData3.option3}`
            //     buttonUnit.insertAdjacentElement("afterend", clonedEl);
                
            // }
            
            setTimeout(() => {
              if (starWrapper && variantData1.sku) {
                const cleanSku = variantData1.sku;
                starWrapper.innerHTML = `<div class="star_container ${cleanSku}"></div>`;
                starWrapper.classList.add(cleanSku);
              }
            }, 3000);
            if(packOfStatus){
              i += 3;
            }else{
              i += 2;
            }
          } else {
            i += 1;
          }

          elIndex++;
        }
      }

      document.querySelectorAll('.card-wrapper').forEach(card => {
        const inputVariantId = card.querySelector('input.product-variant-id');
        const buttonVariants = card.querySelectorAll('.price-label');
        const freeShipping = card.querySelector('.budge__free-shiping');

        if (buttonVariants.length && inputVariantId) {
          const firstBtn = buttonVariants[0];
          const firstId = firstBtn.getAttribute('data-variant-id');
          if (firstId) {
            inputVariantId.value = firstId;
          }

          buttonVariants.forEach(btn => {
            btn.addEventListener('click', () => {
              const variantId = btn.getAttribute('data-variant-id');
              const freeShippingStatus = btn.getAttribute('data-free-shipping') === 'true';
              const isCurrentlySelected = btn.classList.contains('selected');

              if (isCurrentlySelected) {
                btn.classList.remove('selected');
                inputVariantId.value = ''; 
                if (freeShipping) {
                  freeShipping.style.display = 'none';
                }
              } else {
                buttonVariants.forEach(el => el.classList.remove('selected'));
                btn.classList.add('selected');
                inputVariantId.value = variantId;
                if (freeShipping) {
                  freeShipping.style.display = freeShippingStatus ? 'block' : 'none';
                }
              }

              // console.log('Selected variant:', inputVariantId.value, 'Free shipping:', freeShippingStatus);
            });
          });

          buttonVariants.forEach(btn => {
            const hasFreeShipping = btn.getAttribute('data-free-shipping') === 'true';
            if (hasFreeShipping) {
              btn.classList.add('has-free-shipping');
            }
          });
        }
      });

      grid.classList.add('!opacity-100');
      if (pagination) pagination.classList.add('!opacity-100');

    } catch (e) {
      console.error("Failed to parse customJsonData:", e);
    } finally {
      grid.classList.add('!opacity-100');
      if (pagination) pagination.classList.add('!opacity-100');
    }

    const containers = document.querySelectorAll('#free-shipping-card');
    containers.forEach(container => {
      const img = document.createElement('img');
      img.src = "https://cdn.shopify.com/s/files/1/0766/5002/1117/files/free-shipping_1.webp?v=1753930182";
      img.alt = "badge-free-shipping";
      img.width = 0;
      img.height = 25;
      img.id = "free-shipping-img";
      container.appendChild(img);
    });

    observer.disconnect();
  });

  observer.observe(grid, {
    childList: true,
    subtree: true
  });
});